"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitSignedInt64 = exports.limitSignedInt32 = exports.limitSignedInt16 = exports.limitSignedNByteInteger = void 0;
const limitSignedNByteInteger = (int, bytes) => {
    const maxAbs = Math.pow(2, bytes);
    const intAbsMax = maxAbs / 2 - (int > 0 ? 1 : 0); //"The value of \"value\" is out of range. It must be >= -2147483648 and <= 2147483647. Received -2475280486.084"
    return Math.min(Math.abs(int), intAbsMax) * (int !== 0 ? int / Math.abs(int) : 1);
};
exports.limitSignedNByteInteger = limitSignedNByteInteger;
const limitSignedInt16 = (int) => (0, exports.limitSignedNByteInteger)(int, 16);
exports.limitSignedInt16 = limitSignedInt16;
const limitSignedInt32 = (int) => (0, exports.limitSignedNByteInteger)(int, 32);
exports.limitSignedInt32 = limitSignedInt32;
const limitSignedInt64 = (int) => (0, exports.limitSignedNByteInteger)(int, 64);
exports.limitSignedInt64 = limitSignedInt64;
